import { createSlice } from '@reduxjs/toolkit';
import { CustomerInfoJobHistoryState } from '../types/store.types';

const initialState: CustomerInfoJobHistoryState = {
  data: [],
  originalData: [],
};

const filterFunctions = {
  'Status Change': (status: any) => status,
  Comment: (comment: any[]) => comment.filter((item) => item?.description),
  // @ts-expect-error Do not care to this at this point, refactor later
  'Oldest to Newest': (date: any[]) => date.sort((a: any, b: any) => new Date(a.date_time) - new Date(b.date_time)),
  // @ts-expect-error Do not care to this at this point, refactor later
  'Newest to Oldest': (date: any[]) => date.sort((a: any, b: any) => new Date(b.date_time) - new Date(a.date_time)),
};

export const confirmJobHistorySlice = createSlice({
  name: 'jobHistory',
  initialState,
  reducers: {
    jobsHistoryData: (state, action) => {
      state.data = action.payload;
      state.originalData = action.payload;
    },
    filterJobHistoryList: (state, action) => {
      const filter = filterFunctions[action.payload as keyof typeof filterFunctions];
      state.data = filter(state.originalData);
    },
  },
});

export const confirmjobHistoryActions = confirmJobHistorySlice.actions;
export const confirmJobHistoryReducer = confirmJobHistorySlice.reducer;
